import React from "react";
import { Link } from "@reach/router";
import { useQuery } from "@apollo/react-hooks";
import { GET_FRANCHISE_PORTFOLIO_OVERVIEW } from "./services/graphql";
import styles from "./Franchises.module.scss";

const Franchises = () => {
  const { data, loading, error } = useQuery(GET_FRANCHISE_PORTFOLIO_OVERVIEW, {
    fetchPolicy: "network-only"
  });
  const overview = (data && data.franchisePortfolioOverview) || {};
  const franchises = overview.franchises || [];
  const recentActivities = overview.recentActivities || [];

  return (
    <div className={styles.franchises}>
      <div className={styles.header}>
        <h1 className="title">Franchise Management</h1>
        <p>Access and oversee each BoomReader franchise territory.</p>
      </div>
      {loading && <p role="status">Loading franchises...</p>}
      {error && <p role="alert">Unable to load franchises. Please try again later.</p>}
      {!loading && !error && <>
        <div className={styles.section}>
          <h2>Portfolio overview</h2>
          <div className={styles.overview}>
            <div className={styles.overviewCard}>
              <h3>Active territories</h3>
              <strong>{overview.totalFranchises || 0}</strong>
            </div>
            <div className={styles.overviewCard}>
              <h3>Schools</h3>
              <strong>{overview.totalSchools || 0}</strong>
            </div>
            <div className={styles.overviewCard}>
              <h3>Pupil licences</h3>
              <strong>{(overview.totalPupilLicences || 0).toLocaleString("en-GB")}</strong>
            </div>
            <div className={styles.overviewCard}>
              <h3>Franchise admins</h3>
              <strong>{overview.totalFranchiseAdmins || 0}</strong>
            </div>
          </div>
        </div>

        <div className={styles.section}>
          <h2>Territories</h2>
          {franchises.length === 0 && <p>No territories yet.</p>}
          <div className={franchises.length > 3 ? `${styles.territoryList} ${styles.territoryScroll}` : styles.territoryList}>
            {franchises.map(franchise => (
              <div className={styles.territoryCard} key={franchise.id}>
                <div className={styles.territoryDetails}>
                  <span className={styles.countryCode}>{franchise.countryCode}</span>
                  <div>
                    <h3>{franchise.name}</h3>
                    <p className={styles.status}>{franchise.status}</p>
                    {franchise.leadUserName && (
                      <p className={styles.franchiseLead}>Franchise lead: {franchise.leadUserName}</p>
                    )}
                  </div>
                </div>
                <div className={styles.territoryStats}>
                  <div><strong>{franchise.totalSchoolsCount || 0}</strong><span>Schools</span></div>
                  <div><strong>{(franchise.totalPupilLicences || 0).toLocaleString("en-GB")}</strong><span>Pupils</span></div>
                  <div><strong>{franchise.totalTeachers || 0}</strong><span>Teachers</span></div>
                  <div><strong>{franchise.totalParents || 0}</strong><span>Parents</span></div>
                </div>
                <div className={styles.territoryAction}>
                  <Link to={`/franchises/${franchise.id}`} className={styles.primaryButton}>Open {franchise.name}</Link>
                </div>
              </div>
            ))}
          </div>

          <div className={styles.addTerritory}>
            <span className={styles.addIcon} aria-hidden="true">+</span>
            <div className={styles.addDetails}>
              <h3>Add another franchise territory</h3>
              <p>The model can later support Australia, Italy or another market.</p>
            </div>
            <Link to="/franchises/new" className={styles.button}>Add territory</Link>
          </div>
        </div>

        <div className={styles.section}>
          <h2>Recent franchise activity</h2>
          {recentActivities.length === 0 && <p>No recent franchise activity.</p>}
          {recentActivities.length > 0 && (
            <ul className={recentActivities.length > 3 ? `${styles.activityList} ${styles.activityScroll}` : styles.activityList}>
              {recentActivities.map(activity => (
                <li key={activity.id}>
                  <span>{activity.description}</span>
                  <span className={styles.activityDate}>{activity.metaFormatted}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      </>}
    </div>
  );
};

export default Franchises;
